import React from 'react';
import cx from 'clsx';

import styles from './styles.css';
import { ComponentLayout } from '../../types/layout';

export interface IFormLayoutProps {
  layout: ComponentLayout;
  children: React.ReactElement | null;
}

export const FormLayout: React.FC<IFormLayoutProps> = ({ children, layout }) => {
  const rootClass = cx(styles.layout, styles[`layout_${layout}`]);

  return (
    <div className={rootClass} data-testid="form-layout">
      {children}
    </div>
  );
};

FormLayout.displayName = 'FormLayout';
